<template>
    <v-container>
        <Header
            :registryStatus="getContractStatuses"
            :recordIndex="getContractDetails.index"
            :registryTitle="getContractRegistry.name"
            :registryUrl="'contracts'"
            :actualStatus="getContractDetails.status"
            :avatarData="getContractDetails.createdBy"
            @status-changed="changeStatus"
        ></Header>
        <Main :items="items" class="p-relative">
            <v-tab-item
                v-for="item in items"
                :key="item.id"
                slot="tabItems"
                :id="item.id"
            >
                <component :is="item.component"></component>
            </v-tab-item>
            <div slot="information">
                <Information />
                <Modal
                    :title="$t('contracts:editionContract')"
                    :open="open"
                    :height="'520'"
                    v-on:close="closeModal()"
                >
                    <AEContent slot="AEContent" />
                    <Buttons
                        @closeModal="open = false"
                        :action="'edit'"
                        slot="buttons"
                    />
                </Modal>
                <div class="d-flex justify-end buttons--details">
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                fab
                                dark
                                v-on="on"
                                v-if="edit()"
                                small
                                @click="editContract()"
                                class="buttons--add margin--1"
                            >
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('contracts:editContract') }}</span>
                    </v-tooltip>
                </div>
            </div>
        </Main>
    </v-container>
</template>

<script>
import store from './../../../store/index'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Information from '../../../components/Registries/Contracts/Details/Information.vue'
import AEContent from './../../../components/Registries/Contracts/Modal/Content'
import Buttons from './../../../components/Registries/Contracts/Modal/Buttons'

export default {
    i18nOptions: { namespaces: ['global'] },
    components: {
        Information,
        AEContent,
        Buttons,
    },
    data() {
        return {
            open: false,
            items: [],
        }
    },
    computed: {
        ...mapGetters([
            'getContractStatuses',
            'getContractRegistry',
            'getContractDetails',
        ]),
    },
    methods: {
        ...mapMutations([
            'setContractDetails',
            'setContractStatuses',
            'setContractRegistry',
            'setContractModal',
            'clearContractErrors',
            'clearRepresentativesInput',
            'clearContractModal'
        ]),
        ...mapActions(['fetchContract', 'updateContractStatus']),
        changeStatus(status) {
            this.updateContractStatus({ status, id: this.getContractDetails._id })
        },
        edit() {
            return this.checkPermissions('UPDATE')
        },
        async editContract() {
            this.open = true
            this.clearContractErrors()
            this.setContractModal()
        },
        closeModal() {
            this.open = false
            this.clearContractErrors()
            this.clearRepresentativesInput()
            this.clearContractModal()
        },
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch('fetchContract', { id: to.params.id, next })
    },
}
</script>
